module.exports = "https://redage.akamaized.net/src/views/player/reports/images/ra-logo.png";